/* import { createApp } from 'vue'; */
import { ElMessage, ElMessageBox } from 'element-plus'
/* import MessageComponent from '../components/MessageComponent.vue';
import ConfirmDialogComponent from '../components/ConfirmDialog.vue'; */

const MessagePlugin = {
  install(app) {
    /*     // 自定义消息实例
        const MessageInstance = createApp(MessageComponent).mount(document.createElement('div'));
    
        document.body.appendChild(MessageInstance.$el);
    
        // 确认对话框实例
        const ConfirmDialogInstance = createApp(ConfirmDialogComponent).mount(document.createElement('div'));
        document.body.appendChild(ConfirmDialogInstance.$el);
     */
    /*     // 自定义消息方法
        app.config.globalProperties.$message = {
          success(msg) {
            MessageInstance.showMessage(msg, 'success');
          },
          error(msg) {
            MessageInstance.showMessage(msg, 'error');
          }
        }; */

    /*   // 自定义确认对话框方法
      app.config.globalProperties.$baseConfirm = {
        open(options) {
          ConfirmDialogInstance.open(options);
        }
      }; */
    app.config.globalProperties.$baseConfirm = async function (title, message, cb) {
      try {
        // 等待用户确认
        await ElMessageBox.confirm(message, title, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          confirmButtonClass: 'custom-confirm-button',  // 自定义确定按钮的类
          cancelButtonClass: 'custom-cancel-button',  
        });
        if (cb) cb.call();
        return true; // 或者返回你想要的值
      } catch (error) {
        // 用户取消或发生错误
        ElMessage({
          type: 'info',
          message: '操作取消' + error,
        });

        return false; // 或者返回你想要的值
      }
    }
  }
};

export default MessagePlugin;
